;(function (angular) {
  'use strict'
  angular.module('kilo.common.directives')
    .directive('closeUiSelect', CloseUiSelect)

  CloseUiSelect.$inject = []

  function CloseUiSelect () {
    return {
      require: 'uiSelect',
      link: function (scope, element, attrs, $select) {
        scope.$on(attrs.closeUiSelect, (ev, val) => {
          $select.close()
        })
      }
    }
  }

})(window.angular)
